<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear> </a-input>
              </a-form-item>
            </a-col>

            <!--            <a-col :md="8" :sm="24">-->
            <!--              <a-form-item label="邮箱" prop="email">-->
            <!--                <a-input v-model="queryParam.email" placeholder="请输入邮箱" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="昵称" prop="nickname">
                  <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="分销商昵称" prop="nickName">
                  <a-input v-model="queryParam.nickName" placeholder="请输入分销商昵称" allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="设备mac地址" prop="macAddress">
                  <a-input v-model="queryParam.macAddress" placeholder="请输入设备mac地址" allow-clear />
                </a-form-item>
              </a-col>

              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="性别" prop="sex">-->
              <!--                  <a-select placeholder="请选择性别" v-model="queryParam.sex" style="width: 100%" allow-clear>-->
              <!--                    <a-select-option v-for="(d, index) in dict.type.sys_user_sex" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="邀请码" prop="invitationCode">-->
              <!--                  <a-input v-model="queryParam.invitationCode" placeholder="请输入邀请码" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="是否推送" prop="isNotice">-->
              <!--                  <a-select placeholder="请选择是否推送" v-model="queryParam.isNotice" style="width: 100%" allow-clear>-->
              <!--                    <a-select-option v-for="(d, index) in dict.type.sys_notice_status" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="用户状态" prop="status">-->
              <!--                  <a-select placeholder="请选择用户状态" v-model="queryParam.status" style="width: 100%" allow-clear>-->
              <!--                    <a-select-option v-for="(d, index) in dict.type.sys_enable_disable" :key="index" :value="d.value">{{ d.label }}</a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" icon="plus" @click="$refs.createForm.handleAdd()">新增</a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :sexOptions="dict.type.sys_user_sex"
        :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex" />
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice" />
        </span>
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="loginTime" slot-scope="text, record">
          {{ parseTime(record.loginTime) }}
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['biz:user:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['biz:user:remove']"> 删除 </a>
          <a-divider type="vertical" v-hasPermi="['biz:user:remove']" />
          <a @click="handleDeleteData(record)" v-hasPermi="['biz:user:remove']"> 删除用户数据 </a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              用户身体概况
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="$refs.step.getUserBody(record.id)"> 用户步数 </a>
              </a-menu-item>
              <a-menu-item>
                <a @click="$refs.sleep.getUserBody(record.id)"> 用户睡眠 </a>
              </a-menu-item>
              <a-menu-item>
                <a @click="$refs.userBody.getUserBody(record.id)"> 用户身体信息 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.blood.getUserBody(record.id)"> 血压数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.bloodOxygen.getUserBody(record.id)"> 血氧数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.weight.getUserBody(record.id)"> 体重数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.ecg.getUserBody(record.id)"> Ecg数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.hrv.getUserBody(record.id)"> Hrv数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.bodytemperature.getUserBody(record.id)"> 体温数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.pressure.getUserBody(record.id)"> 压力数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.heartRecord.getUserBody(record.id)"> 心率数据 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.bodyCompositionRecord.getUserBody(record.id)"> 身体成分 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.bloodSugar.getUserBody(record.id)"> 血糖检测 </a>
              </a-menu-item>

              <a-menu-item>
                <a @click="$refs.bloodComponents.getUserBody(record.id)"> 血液成分 </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <!--          <a @click="$refs.createForm.handleUpdate(record, undefined)">-->
          <!--           <a-tag color="pink">用户步数</a-tag>-->
          <!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <step ref="step"></step>
    <sleep ref="sleep"></sleep>
    <user-body ref="userBody"></user-body>
    <blood ref="blood"></blood>
    <blood-oxygen ref="bloodOxygen"></blood-oxygen>
    <weight ref="weight"></weight>
    <ecg ref="ecg"></ecg>
    <hrv ref="hrv"></hrv>
    <bodytemperature ref="bodytemperature"></bodytemperature>
    <pressure ref="pressure"></pressure>
    <heartRecord ref="heartRecord"></heartRecord>
    <bodyCompositionRecord ref="bodyCompositionRecord"></bodyCompositionRecord>
    <bloodSugar ref="bloodSugar"></bloodSugar>
    <bloodComponents ref="bloodComponents"></bloodComponents>
  </page-header-wrapper>
</template>

<script>
import { pageUser, listUser, delUser, deleteUserData } from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import step from '../../joe/step/index'
import { tableMixin } from '@/store/table-mixin'
import sleep from '../../joe/sleep/index'
import userBody from '../../joe/body/index'
import blood from '../../joe/blood/index'
import bloodOxygen from '../../joe/bloodOxygen/index'
import weight from '../../joe/weight/index'
import ecg from '../../joe/ecg/index'
import hrv from '../../joe/hrv/index'
import bodytemperature from '../../joe/bodytemperature/index'
import pressure from '../../joe/pressure/index'
import heartRecord from '../../joe/heartRecord/index'
import bodyCompositionRecord from '../../joe/bodyCompositionRecord/index'
import bloodSugar from '../../joe/bloodSugar/index'
import bloodComponents from '../../joe/bloodComponents/index'

export default {
  name: 'User',
  components: {
    bloodOxygen,
    bloodSugar,
    pressure,
    bodyCompositionRecord,
    bloodComponents,
    weight,
    heartRecord,
    bodytemperature,
    blood,
    ecg,
    hrv,
    userBody,
    sleep,
    CreateForm,
    step,
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '邮箱',
        //   dataIndex: 'email',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center',
        },
        {
          title: 'Mac地址',
          dataIndex: 'macAddress',
          ellipsis: true,
          align: 'center',
        },

        {
          title: '性别',
          dataIndex: 'sex',
          customRender: function (t) {
            if (t == 1) {
              return '男'
            } else {
              return '女'
            }
          },
          ellipsis: true,
          align: 'center',
        },

        {
          title: '代理商账号',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center',
        },

        {
          title: '代理商昵称',
          dataIndex: 'sysName',
          ellipsis: true,
          align: 'center',
        },
        // {
        //   title: '生日',
        //   dataIndex: 'birthday',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '邀请码',
        //   dataIndex: 'invitationCode',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '是否推送',
        //   dataIndex: 'isNotice',
        //   scopedSlots: { customRender: 'isNotice' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '用户状态',
        //   dataIndex: 'status',
        //   scopedSlots: { customRender: 'status' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '上次登录时间',
          dataIndex: 'loginTime',
          scopedSlots: { customRender: 'loginTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询用户信息列表 */
    getList() {
      console.log(11111111111111111111111111)
      console.log(this.$store.state.userInfo)
      this.loading = true
      pageUser(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中的用户为【' + row.nickname + '】',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delUser(row.id).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    handleDeleteData(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中的用户为【' + row.nickname + '】',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return deleteUserData(row.id).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'biz/user/export',
            {
              ...that.queryParam,
            },
            `用户信息_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>


